var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M22.507,21H14.994a3.005,3.005,0,0,1-6.01,0H1.471A1.443,1.443,0,0,1,.119,19.95,1.6,1.6,0,0,1,.57,18.3a6.035,6.035,0,0,0,2.4-4.8V9A9.015,9.015,0,0,1,21,9v4.5a6.035,6.035,0,0,0,2.4,4.8,1.419,1.419,0,0,1,.451,1.65A1.443,1.443,0,0,1,22.507,21Z",
    transform: "translate(-0.063)",
    fill: "#324562",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.ec87268c18008776cae898b2b1dfc200.svg";
export { ForwardRef as ReactComponent };